export default __webpack_public_path__ + "static/media/vip-2.ccca6015.gif";